import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo3.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  height: "24",
  src: _imports_0,
  style: {"margin-top":"18px"}
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_3 = { class: "dialog-footer" }

import { ref, reactive, getCurrentInstance } from 'vue'
  import {useRouter} from 'vue-router'
  import { useAlone } from '@/store';
  import pinia from '@/store/store';
  import { ElMessage, ElLoading } from 'element-plus'
  import api from '@/api/index'
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

  const router = useRouter()
  const form = reactive({
    repassword:'',
    password:'',
  });
  const alone = useAlone(pinia)

  const username = localStorage.getItem('username')
  const ispwsbox = ref(false)
  const showpwsbox  = () => {
    ispwsbox.value = true
  }
  const changepwd  = () => {
    if(form.repassword != form.password){
      ElMessage.error('新密码与确认密码不一致')
      return
    }
    const loading = ElLoading.service({
      lock: true,
    })
    api.aloneApi.changepwd(form).then((response:any) => {
      loading.close()
      if(response.code == 200){
        ElMessage({
          message: response.message,
          type: 'success',
        })
        ispwsbox.value = false
      } else if (response.code == 1002) {
        // 当前已经登录
        router.push({path: '/'})
      }else{
        ElMessage.error(response.message)
      }
    }).catch((response:any) => {
        ElMessage.error(response.message);
    })
  }
  const loginout  = () => {
    const loading = ElLoading.service({
      lock: true,
    })
    api.aloneApi.loginout({}).then((response:any) => {
      loading.close()
      if(response.code == 200){
        localStorage.setItem('userId', '')
        localStorage.setItem('username', '')
        localStorage.setItem('token', '')
        ElMessage({
          message: response.message,
          type: 'success',
        })
        localStorage.setItem('userId', '')
        localStorage.setItem('username', '')
        alone.setLoginStatus(false)
        localStorage.setItem('sessionId','')
        router.push({path: '/login'})
      } else if (response.code == 1002) {
        // 当前已经登录
        router.push({path: '/'})
      }else{
        ElMessage.error(response.message)
      }
    }).catch((response:any) => {
        ElMessage.error(response.message);
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu, {
          class: "el-menu-demo",
          mode: "horizontal",
          ellipsis: false
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, { index: "0" }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_component_el_menu_item, { index: "1" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(username)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "2",
              onClick: showpwsbox
            }, {
              default: _withCtx(() => [
                _createTextVNode("修改密码")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "3",
              onClick: loginout
            }, {
              default: _withCtx(() => [
                _createTextVNode("退出")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: ispwsbox.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((ispwsbox).value = $event)),
      title: "修改密码"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_3, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (ispwsbox.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: changepwd
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 确认 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "新密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.password,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.password) = $event)),
                  type: "password",
                  placeholder: "",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "确认密码" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.repassword,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.repassword) = $event)),
                  type: "password",
                  placeholder: "",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})